import React from "react";
import { PageHeader, Section } from "@/components/ui-kit";
import { Download, FileSpreadsheet, BarChart3 } from "lucide-react";

function downloadWithAuth(path, filename) {
  const url = `${process.env.REACT_APP_BACKEND_URL}${path}`;
  const token = localStorage.getItem("access_token");
  fetch(url, { credentials: "include", headers: token ? { Authorization: `Bearer ${token}` } : {} })
    .then(r => r.blob()).then(b => {
      const a = document.createElement("a"); a.href = URL.createObjectURL(b); a.download = filename; a.click();
    });
}

function Card({ icon: Icon, title, description, onClick, testid }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className="text-left bg-surface border border-line rounded-sm p-6 hover:-translate-y-[2px] hover:shadow-sm transition-all flex gap-4">
      <div className="w-12 h-12 rounded-sm bg-brand/10 text-brand flex items-center justify-center shrink-0">
        <Icon size={20} strokeWidth={1.5} />
      </div>
      <div className="flex-1">
        <div className="font-heading text-lg text-ink">{title}</div>
        <div className="text-sm text-ink2 mt-1">{description}</div>
        <div className="text-xs text-brand mt-3 inline-flex items-center gap-1"><Download size={12} /> Descargar</div>
      </div>
    </button>
  );
}

export default function Reports() {
  return (
    <div data-testid="reports-page">
      <PageHeader title="Informes" subtitle="Exporta los datos clave a CSV o Excel para tu contabilidad o análisis." />
      <Section title="Exportaciones disponibles">
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-5">
          <Card
            icon={FileSpreadsheet}
            title="Stock consolidado (Excel)"
            description="Todos los títulos con su stock en almacén propio, distribuidor y depósito en cliente."
            testid="report-stock-xlsx"
            onClick={() => downloadWithAuth("/api/reports/stock.xlsx", "stock.xlsx")}
          />
          <Card
            icon={BarChart3}
            title="Stock consolidado (CSV)"
            description="Misma información en CSV con separador ;"
            testid="report-stock-csv"
            onClick={() => downloadWithAuth("/api/reports/stock.csv", "stock.csv")}
          />
        </div>
      </Section>
    </div>
  );
}
